import React from 'react';
import { Container, OptionsWrapper } from './EventTypeOptions.styled';
import { stringifyURL } from '../../../modules/formatting';
import { PATHS } from '../../../constants/paths';
import { Icons, LinkButton } from '@feast-it/ui/light';
import { EventType } from '../../../types';
import { trackEvent } from '../../../modules/analytics';
import {
  EVENT_TYPE_CLICKED,
  GET_QUOTES_CLICKED,
} from '../../../constants/analytics';
import { useRouter } from 'next/router';
import { getAbsoluteUrl } from '@/helpers/formatUrl';

interface EventTypeOptionsProps {
  descriptorVariable: any;
  eventTypes: EventType[];
  isMobile: boolean;
}

export function EventTypeOptions({
  descriptorVariable,
  eventTypes,
  isMobile,
}: EventTypeOptionsProps) {
  const router = useRouter();

  return (
    <Container>
      <h2>Tell us what you&apos;re planning...</h2>
      <OptionsWrapper>
        {eventTypes?.map(type => {
          const query = {
            type: type?.value || '',
            ...(descriptorVariable?.filters || {}),
          };

          const href = stringifyURL(PATHS.enquiryForm, query);

          return (
            <LinkButton
              key={type.name}
              icon={type.icon as keyof Icons}
              href={href}
              color="white"
              variant="solid"
              onClick={() =>
                trackEvent(EVENT_TYPE_CLICKED, {
                  source: 'seo hero',
                  event_type: type.name,
                  currentPage: getAbsoluteUrl(router.asPath),
                  destinationUrl: getAbsoluteUrl(href),
                })
              }
            >
              {type.name}
            </LinkButton>
          );
        })}
      </OptionsWrapper>

      <LinkButton
        data-testid="get-quotes-hero-button"
        href={PATHS.enquiryForm}
        color="paleYellow"
        variant="solid"
        size="large"
        isFullWidth={isMobile}
        onClick={() =>
          trackEvent(GET_QUOTES_CLICKED, {
            source: 'hero',
            currentPage: getAbsoluteUrl(router.asPath),
            destinationUrl: getAbsoluteUrl(PATHS.enquiryForm),
          })
        }
      >
        Get quotes
      </LinkButton>
    </Container>
  );
}
